import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuDiscountComponent from './discount.component';

const menuDiscountModule = angular.module('tinaba.components.menu.discount', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu.discount', {
    url: '/discount',
    template: '<menu-discount></menu-discount>'
  });
})

.component('menuDiscount', MenuDiscountComponent);

export default menuDiscountModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/discount/discount.js
 **/